//#region src/formatters/kebab-case/to-kebab-case.ts
const toKebabCase = (str) => {
	if (!str) return "";
	return str.replaceAll(/[^\dA-Za-z]/g, "").replaceAll(/([A-Z])/g, "-$1").toLowerCase().replace(/^-/, "");
};

//#endregion
export { toKebabCase };